import React, { useEffect, useState } from 'react';
import useCorsiUtenti from '../../hooks/useCorsiUtenti';
import useUtenti from '../../hooks/useUtenti';
import CustomModal from '../../components/CustomModal/CustomModal';
import { Dropdown, OverlayTrigger, Spinner, Tooltip, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ROLES } from '../../model/roles';
import useMediaQuery from '../../hooks/useMediaQuery';
import { alertService } from '../../services/AlertService';
import CustomFilterTable from '../../components/CustomFilterTable/CustomFilterTable';
import useAuth from '../../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router';
import UsersToCourseManager from '../../components/UsersToCourseManager/UsersToCourseManager';
import CustomPagination from '../../components/CustomPagination/CustomPagination';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';
import UtilityService from '../../services/UtillityServices/UtilityService';
import { TIPO_CORSO } from '../../model/tipoCorso';
import useAttestati from '../../hooks/useAttestati';
import useEsamiUtenti from '../../hooks/useEsamiUtenti';
import AttestatiManager from '../../components/AttestatiManager/AttestatiManager';
import SpedizioneAttestatoModal from '../../components/SpedizioneAttestatoModal/SpedizioneAttestatoModal';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import SelectRecipientModal from '../../components/SelectRecipientModal/SelectRecipientModal'; // <-- Importa la nuova modale

const GestioneCorsiUtentiPage = () => {
    // Hooks
    const { assignCourseToUser, modalStateCorsiUtenti, loadingStateCorsiUtenti, setModalStateCorsiUtenti, deleteCorsiUtenti, updateCorsiUtenti } = useCorsiUtenti();
    const { loadingStateUtenti, getUtenteByParams, getTabCounts, downloadActivityReport } = useUtenti();
    const { getEsamiUtentiByIdClasseUtente } = useEsamiUtenti();
    const { generaAttestato, loadingStateAttestati, modalStateAttestati, setModalStateAttestati, aggiornaSpedizioneAttestato, stampaBustaAttestato } = useAttestati();
    const { isLoading: isAuthLoading } = useAuth();

    // Stati del componente
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const location = useLocation();
    const courseData = location.state?.courseData;
    const userLoggedIn = useSelector(state => state.user.userData);
    const navigate = useNavigate();

    // --- NUOVA GESTIONE DEGLI STATI PER I TAB ---
    const [activeTab, setActiveTab] = useState('inCorso'); // Tab di default
    const [utenti, setUtenti] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filters, setFilters] = useState({});
    
    // Stati per le varie modali (invariati)
    const [showFilterTable, setShowFilterTable] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUtente, setSelectedUtente] = useState(null);
    const [esamiUtente, setEsamiUtente] = useState(null);
    const [selectedEsame, setSelectedEsame] = useState(null);
    const [newStatoPagamento, setNewStatoPagamento] = useState("");
    const [newStatoFatturazione, setNewStatoFatturazione] = useState("");
    const [numeroFattura, setNumeroFattura] = useState("");
    const [paymentStatePerUser, setPaymentStatePerUser] = useState({});
    const { updateStatoVerifica } = useClassiUtenti();
    const [selectedSoggettoForPrint, setSelectedSoggettoForPrint] = useState('corsista');
    
    // Stati specifici per la modale di assegnazione utenti
    const [selectedPageModal, setSelectedPageModal] = useState(1);
    const [formDataFilterModal, setFormDataFilterModal] = useState({});
    const [totalPagesModal, setTotalPagesModal] = useState(1);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [countDataFiltered, setCountDataFiltered] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [formAssegnaCorso, setFormAssegnaCorso] = useState({});
    const [tabCounts, setTabCounts] = useState({ inCorso: 0, completati: 0, archiviati: 0 });

    const [showVerificaModal, setShowVerificaModal] = useState(false);
    const [selectedUserForVerifica, setSelectedUserForVerifica] = useState(null);
    const [verificaStatus, setVerificaStatus] = useState('da_verificare');
    const [verificaNotes, setVerificaNotes] = useState('');
    const [fontePagamento, setFontePagamento] = useState(0); // Default a 'Corsista' (0)

    // Stato per tenere traccia dell'utente selezionato per la stampa
    const [userForEnvelopePrint, setUserForEnvelopePrint] = useState(null);

    // --- NUOVA FUNZIONE DI CARICAMENTO DATI ---
    const fetchUtentiForTab = async (tab, page, currentFilters) => {
        if (!courseData?.id_corso) {
            navigate("/gestione-corsi");
            return;
        }

        setIsLoading(true);

        let statoFormazioneFilter;
        switch (tab) {
            case 'inAttesaEsame':
                statoFormazioneFilter = 'In Attesa Esame';
                break;
            case 'archiviati':
                statoFormazioneFilter = 'Formazione Conclusa';
                break;
            case 'inCorso':
            default:
                statoFormazioneFilter = 'In Corso';
                break;
        }

        const apiPayload = {
            filtri: {
                ...currentFilters,
                id_corso: courseData.id_corso,
                tipo_utente: "corsista",
                stato_formazione: statoFormazioneFilter
            },
            limite: 10,
            pagina: page,
            ordinamento: "tipo_utente asc, corsi_utenti.data_inserimento desc"
        };

        try {
            const res = await getUtenteByParams(apiPayload); 
            setUtenti(res?.data || []);
            setTotalPages(Math.ceil(res?.count / apiPayload.limite) || 1);
            setCurrentPage(page);
        } catch (error) {
            console.error("Errore nel caricamento degli utenti:", error);
            alertService.error("Si è verificato un errore nel caricamento degli utenti.");
            setUtenti([]);
            setTotalPages(1);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        const fetchCounts = async () => {
            if (courseData?.id_corso) {
                // Assumendo che tu abbia creato getTabCounts in useUtenti
                const counts = await getTabCounts({ filtri: { id_corso: courseData.id_corso } });
                if (counts) {
                    setTabCounts(counts);
                }
            }
        };
        fetchCounts();
    }, [courseData]);
    
// --- INIZIO BLOCCO DI LOGICA UNIFICATO ---

    // Funzione per aggiornare i conteggi. È definita qui, UNA SOLA VOLTA.
    const fetchAndUpdateCounts = async (currentFilters) => {
        if (!courseData?.id_corso) return;
        const payload = { filtri: { ...currentFilters, id_corso: courseData.id_corso } };
        const counts = await getTabCounts(payload);
        if (counts) {
            setTabCounts(counts);
        }
    };

    // useEffect centralizzato che si occupa di TUTTI i caricamenti dati.
    useEffect(() => {
        if (courseData?.id_corso) {
            fetchUtentiForTab(activeTab, currentPage, filters);
            fetchAndUpdateCounts(filters);
        }
    }, [activeTab, currentPage]); // Si attiva al cambio tab o cambio pagina

    // Le funzioni "handle" ora modificano solo lo stato.
    // Sarà l'useEffect a reagire e a far partire le chiamate.

    const handleTabSelect = (tab) => {
        if (tab === activeTab) return; // Evita ricaricamenti se si clicca lo stesso tab

        setActiveTab(tab);
        setCurrentPage(1);

        // NUOVA LOGICA:
        // Mantiene il filtro 'id_agenzia' se esiste, altrimenti resetta a un oggetto vuoto.
        // Questo assicura che il filtro dell'agenzia rimanga "appiccicato" quando cambi tasca.
        setFilters(prevFilters => {
            if (prevFilters.id_agenzia) {
                return { id_agenzia: prevFilters.id_agenzia };
            }
            return {};
        });
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleFilterSubmit = () => {
        // Applica i filtri e aggiorna sia la lista che i conteggi
        setCurrentPage(1);
        fetchUtentiForTab(activeTab, 1, filters);
        fetchAndUpdateCounts(filters);
    };

    // La logica della modale rimane invariata e separata
    const onFilteredTableModal = async () => { /* ... la tua logica esistente ... */ };
    useEffect(() => { if (courseData?.id_corso) { onFilteredTableModal(); } }, [selectedPageModal]);
    
    // --- FINE BLOCCO DI LOGICA UNIFICATO ---
    
    const handleCloseModal = () => {
        setModalStateCorsiUtenti(state => ({ ...state, assignCourseToUser: false, deleteCorsiUtenteModal: false, updateCorsiUtenteModal: false, updateStatoFatturazioneModal: false, updateSpedizioneModal: false }));
        setModalStateAttestati(state => ({ ...state, showModalGeneraAttestato: false }));
        setDataFiltered([]);
        setSelectedUsers([]);
        setFormDataFilterModal({});
        setCountDataFiltered(null);
        setSelectedEsame('');
        setEsamiUtente(null);
    };

    const openAssegnCourseModal = () => { setModalStateCorsiUtenti(state => ({ ...state, assignCourseToUser: true })); };
    const openDeleteCourseModal = (user) => { setSelectedUser(user); setModalStateCorsiUtenti(state => ({ ...state, deleteCorsiUtenteModal: true })); };
    const openUpdateStatoPagamentoModal = (user) => { setNewStatoPagamento(user?.stato_pagamento); setFontePagamento(user?.pagamento_partner || 0);  setSelectedUser(user); setModalStateCorsiUtenti(state => ({ ...state, updateCorsiUtenteModal: true })); };
    const openUpdateStatoFatturazioneModal = (user) => { setNewStatoFatturazione(user?.stato_fatturazione); setNumeroFattura(user?.fattura || ""); setSelectedUser(user); setModalStateCorsiUtenti(state => ({ ...state, updateStatoFatturazioneModal: true })); };
    const openGeneraAttestatoModal = async (user) => { setSelectedUser(user); setEsamiUtente(null); setModalStateAttestati(state => ({ ...state, showModalGeneraAttestato: true })); const obj = { id_classe_utente: user.id_classe_utente }; const res = await getEsamiUtentiByIdClasseUtente(obj); setEsamiUtente(res); };
    const openSpedizioneModal = (user) => { setSelectedUtente(user); setModalStateCorsiUtenti(prev => ({ ...prev, updateSpedizioneModal: true })); };

    const openVerificaModal = (user) => {
        setSelectedUserForVerifica(user);
        setVerificaStatus(user.stato_verifica_amministrativa || 'da_verificare');
        setVerificaNotes(user.note_verifica_amministrativa || '');
        setShowVerificaModal(true);
    };

    const handleCloseVerificaModal = () => {
        setShowVerificaModal(false);
        setSelectedUserForVerifica(null);
    };

    const onSaveVerifica = async () => {
        if (!selectedUserForVerifica) return;

        await updateStatoVerifica({
            id_classe_utente: selectedUserForVerifica.id_classe_utente,
            stato_verifica: verificaStatus,
            note: verificaNotes
        });
        
        handleCloseVerificaModal();
        fetchUtentiForTab(activeTab, currentPage, filters); // Ricarica la lista per mostrare le modifiche
    };

    const onDeleteCorsiUtente = async () => {
        const obj = { id_corso_utente: selectedUser?.id_corso_utente, nome: selectedUser?.nome, cognome: selectedUser?.cognome };
        if (selectedUser?.tipo_utente === "corsista") { obj.id_utente = selectedUser?.id_utente; }
        await deleteCorsiUtenti(obj);
        fetchUtentiForTab(activeTab, currentPage, filters);
        handleCloseModal();
    };

    const onUpdateCorsiUtente = async () => {
        if (newStatoPagamento !== "") {
            const obj = {
                id_corso_utente: selectedUser?.id_corso_utente,
                stato_pagamento: newStatoPagamento,
                pagamento_partner: newStatoPagamento === 'Pagato' ? fontePagamento : selectedUser?.pagamento_partner,
                stato_fatturazione: selectedUser?.stato_fatturazione,
                fattura: selectedUser?.fattura, // <-- AGGIUNGI QUESTA RIGA
                id_utente: selectedUser?.id_utente,
                id_corso: courseData?.id_corso
            };
            await updateCorsiUtenti(obj);
            fetchUtentiForTab(activeTab, currentPage, filters);
        }
        handleCloseModal();
    };

    const onUpdateStatoFatturazione = async () => {
        if (newStatoFatturazione === 'Fatturato' && !numeroFattura.trim()) { alertService.warn('Per lo stato "Fatturato" è obbligatorio inserire il numero fattura.'); return; }
        const obj = { id_corso_utente: selectedUser?.id_corso_utente, stato_pagamento: selectedUser?.stato_pagamento, stato_fatturazione: newStatoFatturazione, fattura: newStatoFatturazione === 'Fatturato' ? numeroFattura : null };
        await updateCorsiUtenti(obj);
        fetchUtentiForTab(activeTab, currentPage, filters);
        handleCloseModal();
    };

    const onGeneraAttestato = async (esameSelezionato) => {
        if (!esameSelezionato) { alertService.warn("Per favore, seleziona un esame prima di generare l'attestato."); return; }
        try {
            const response = await generaAttestato({ id_utente: selectedUser?.id_utente, id_corso: esameSelezionato.esame?.id_corso, data_esame: esameSelezionato.esame?.data, id_classe_utente: selectedUser?.id_classe_utente });
            if (response && response.success && response.url_real) { fetchUtentiForTab(activeTab, currentPage, filters); handleCloseModal(); } 
            else { alertService.error("Generazione completata, ma si è verificato un problema nell'aggiornare l'interfaccia."); handleCloseModal(); }
        } catch (error) { console.error("Errore durante il processo di generazione:", error); }
    };
    
    const handleEsameSelect = (esameId) => { setSelectedEsame(esameId); };
    const handlePageChangeModal = (page) => { setSelectedPageModal(page); };
    const handleUserSelection = (utente) => { if (selectedUsers.some(user => user.id_utente === utente.id_utente)) { setSelectedUsers(prev => prev.filter(user => user.id_utente !== utente.id_utente)); } else { setSelectedUsers(prev => [...prev, utente]); } };
    const handleStatoPagamentoChange = (userId, event) => { const selectedOption = event.target.value; setPaymentStatePerUser((prevState) => ({ ...prevState, [userId]: selectedOption })); };

    const onAssignCorsiUtente = async () => {
        let validationCorsisti = [];
        const corsisti = selectedUsers.filter(user => user.tipo_utente === "corsista");
        for (const corsista of corsisti) { if (!paymentStatePerUser[corsista.id_utente]) { validationCorsisti.push(`${corsista.nome} ${corsista.cognome}`); } }
        if (validationCorsisti.length > 0) { alertService.warn(`Seleziona uno stato di pagamento per ${validationCorsisti.join(', ')}`, { autoClose: true }); return; }
        for (const user of selectedUsers) { const obj = { nome: user.nome, cognome: user.cognome, stato_pagamento: paymentStatePerUser[user.id_utente] ?? "Non_pagato", id_corso: courseData.id_corso, id_utente: user.id_utente, tipo_utente: user.tipo_utente, modalita_erogazione: courseData.modalita_erogazione }; await assignCourseToUser(obj, false, true); }
        fetchUtentiForTab(activeTab, currentPage, filters);
        handleCloseModal();
    };

    const renderCardUserToCheck = () => ( <div className='row'>{dataFiltered?.map(utente => ( <div role='button' className='col-sm-12 col-xl-6 my-2' key={utente.id_utente} onClick={() => handleUserSelection(utente)}><div className={`card custom-user-card p-3 ${selectedUsers.some(user => user.id_utente === utente.id_utente) ? 'border border-success' : ''}`}><div className='d-flex justify-content-between'><div className='d-flex gap-3'><div className={`custom-icon-container`}><i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i></div><div className='align-self-center'><span className='d-block small'>{utente.nome} {utente.cognome}</span><span className='d-block small text-muted'>{utente.username}</span><span className="badge text-bg-primary">{(utente.tipo_utente === "course_designer") ? "course designer" : utente.tipo_utente}</span></div></div></div></div></div>))}</div> );
    const renderAssignUserToCourseModal = () => ( <><CustomFilterTable formDataFilter={formDataFilterModal} setFormDataFilter={setFormDataFilterModal} onFilteredTable={onFilteredTableModal} isLoadingData={loadingStateUtenti.isLoadingUtenteByParamsModal} isModalView={true} isAssegnaCorso={true} searchNodeType={[ { nodeType: "input", name: "nome" }, { nodeType: "input", name: "cognome" }, { nodeType: "input", name: "username", placeholder: "email" }, { nodeType: "select", name: "tipo_utente" }, { nodeType: "select", name: "id_agenzia" } ]} />{!loadingStateUtenti.isLoadingUtenteByParamsModal ? ( <div className='my-3'>{countDataFiltered >= 1 ? ( <><h5>Risultati trovati: {countDataFiltered}</h5>{renderCardUserToCheck()}<div className='my-3 d-flex justify-content-end'><CustomPagination totalPages={totalPagesModal} selectedPage={selectedPageModal} handlePageChange={handlePageChangeModal} /></div></> ) : ("Nessun risultato trovato")}</div> ) : ( <div className='m-auto text-center my-5'><p className='mt-5'>Caricando gli utenti...</p><Spinner animation="border" /></div> )}{selectedUsers.length > 0 && ( <div className='mt-4'><h5>Utenti selezionati: {selectedUsers.length}</h5><div className='row'>{selectedUsers.map(utente => ( <div className='col-sm-12 col-xl-6 my-2' key={utente.id_utente}><div className={`card custom-user-card p-3`}><div className='d-flex justify-content-between'><div className='d-flex gap-3 custom-card-title'><div className={`custom-icon-container`}><i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i></div><div className='align-self-center'><span className='d-block small'>{utente.nome} {utente.cognome}</span><span className="badge text-bg-primary mx-1">{utente.tipo_utente.replace("_", " ")}</span>{(utente.tipo_utente === "corsista") && (<span className={`badge ${UtilityService.getBadgeColorClass(paymentStatePerUser[utente.id_utente])} mx-1`}>{UtilityService.getPaymentState(paymentStatePerUser[utente.id_utente])}</span>)}</div></div><div className='d-flex gap-1'>{utente.tipo_utente === "corsista" && <select name="stato_pagamento" style={{ borderRadius: "20px" }} className="form-control form-control-sm" value={paymentStatePerUser[utente.id_utente] || ''} onChange={(e) => handleStatoPagamentoChange(utente.id_utente, e)}><option value="">Stato pagamento</option><option value="Non_pagato">Non pagato</option><option value="Pagato">Pagato</option><option value="Parzialmente_pagato">Parzialmente pagato</option></select>}<div className='align-self-center'><OverlayTrigger placement="top" overlay={<Tooltip>Rimuovi utente</Tooltip>}><i role='button' onClick={() => handleUserSelection(utente)} className='bi bi-x-circle-fill text-danger fs-4 mx-1'></i></OverlayTrigger></div></div></div></div></div>))}</div></div> )}</> );
    const renderUpdateStatoFatturazioneModal = () => ( <><span className="d-block fs-5">Stato fatturazione di <b>{selectedUser?.nome} {selectedUser?.cognome}</b></span><select name="stato_fatturazione" style={{ borderRadius: "20px" }} className="form-control mt-3" value={newStatoFatturazione} onChange={(e) => setNewStatoFatturazione(e.target.value)}><option value="Non_fatturato">Da fatturare</option><option value="Fatturato">Fatturato</option></select>{newStatoFatturazione === 'Fatturato' && ( <div className="mt-3"><label htmlFor="numero_fattura" className="form-label">Numero Fattura</label><input type="text" id="numero_fattura" className="form-control" placeholder="Es. 150/25" value={numeroFattura} onChange={(e) => setNumeroFattura(e.target.value)} /></div> )}</> );
    const renderUpdateCourseInfoPerUserModal = () => ( <><span className="d-block fs-5">Stato pagamento di <b>{selectedUser?.nome} {selectedUser?.cognome}</b></span><select name="stato_pagamento" style={{ borderRadius: "20px" }} className="form-control mt-3" value={newStatoPagamento} onChange={(e) => setNewStatoPagamento(e.target.value)}><option value="Non_pagato">Non pagato</option><option value="Pagato">Pagato</option><option value="Parzialmente_pagato">Parzialmente pagato</option></select>        {/* Questo blocco appare solo se lo stato del pagamento è "Pagato" */}
        {newStatoPagamento === 'Pagato' && (
            <div className="mt-4">
                <label htmlFor="fonte_pagamento" className="form-label fw-bold">Fonte del Pagamento:</label>
                <select
                    id="fonte_pagamento"
                    name="fonte_pagamento"
                    className="form-select"
                    value={fontePagamento}
                    onChange={(e) => setFontePagamento(parseInt(e.target.value, 10))}
                >
                    {/* ===== OPZIONI AGGIORNATE E CORRETTE ===== */}
                    <option value="0">Non Assegnato</option>
                    <option value="1">Corsista</option>
                    <option value="2">Partner</option>
                    <option value="3">Superpartner</option>
                </select>
            </div>
        )} </>  );
    const renderDeleteCorsiUtente = () => ( <><span className="d-block fs-4 mb-2"><b>Vuoi rimuovere l'utente dal corso?</b> </span><span className="d-block fs-5">{selectedUser?.nome} {selectedUser?.cognome}</span></> );
        const handleDownloadReport = (user) => {
        if (user && courseData) {
            downloadActivityReport(user.id_utente, courseData.id_corso);
        }
    };

    // Funzione per APRIRE la nuova modale
    const openSelectRecipientModal = (user) => {
        // Assicurati che 'user' contenga id_attestato e id_agenzia
        setUserForEnvelopePrint(user); 
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: true }));
    };

    // Funzione per CHIUDERE la nuova modale
    const handleCloseSelectRecipientModal = () => {
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: false }));
        setUserForEnvelopePrint(null); // Pulisci l'utente selezionato
    };

    // Funzione chiamata al click su "Salva e Stampa" nella nuova modale
// /pages/GestioneCorsiUtenti/GestioneCorsiUtentiPage.js

    const handleConfirmRecipientAndPrint = async () => {
        // ... (check userForEnvelopePrint) ...
        const currentSelectedSoggetto = selectedSoggettoForPrint;
        // ... (check hasAgenzia) ...

        // 1. Salva il soggetto selezionato
        const saveSuccess = await aggiornaSpedizioneAttestato({ // <-- PRIMA CHIAMATA API
            id_attestato: userForEnvelopePrint.id_attestato,
            soggetto_spedizione: currentSelectedSoggetto,
        });

        // 2. Se il salvataggio va a buon fine, avvia la stampa
        if (saveSuccess) { // <--- PUNTO CRITICO
            console.log("Salvataggio riuscito, procedo con la stampa..."); // Aggiungi questo log
            await stampaBustaAttestato({ // <-- SECONDA CHIAMATA API (viene fatta solo se saveSuccess è true)
                id_attestato: userForEnvelopePrint.id_attestato
            });
            handleCloseSelectRecipientModal();
            fetchUtentiForTab(activeTab, currentPage, filters);
        } else {
            console.error("Salvataggio fallito, stampa annullata."); // Aggiungi questo log
            // L'alert di errore generico probabilmente viene da qui o dall'hook
        }
    };

    const handleSaveSpedizione = async (dataFromModal) => {
        // Estrai solo i dati necessari (escludi soggetto_spedizione se presente)
        const dataToSave = {
            id_attestato: dataFromModal.id_attestato,
            data_spedizione: dataFromModal.data_spedizione,
            tracking_spedizione: dataFromModal.tracking_spedizione
        };

        const success = await aggiornaSpedizioneAttestato(dataToSave);
        if (success) {
            handleCloseModal(); // Chiudi la modale Spedizione
            fetchUtentiForTab(activeTab, currentPage, filters); // Aggiorna la lista
        }
        // Se saveSuccess è false, l'hook ha già mostrato l'errore
    };

    const handleSubjectChangeForPrint = (newSoggetto) => {
         setSelectedSoggettoForPrint(newSoggetto);
    };

    return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`} style={{ minHeight: "700px" }}>
                <div className="container">
                    <ComebackArrow path={"/gestione-corsi"} />
                    <div className="d-flex justify-content-between custom-card-header">
                        <div className="d-flex gap-3 custom-card-title my-2">
                            <div className={`custom-icon-container`}>
                                {courseData?.immagine_corso ? <img src={courseData.immagine_corso} className='custom-icon' alt='immagine corso'/> : <i className={`bi custom-icon bi-mortarboard fs-2`}></i> }
                            </div>
                            <div className="align-self-center"><span className="fs-4 d-block"><i><b>{courseData?.denominazione}</b></i></span></div>
                        </div>
                        {(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
                            <div className='align-self-center my-2'><button type='button' className='btn btn-primary' onClick={openAssegnCourseModal}>Assegna utente</button></div>
                        )}
                    </div>
                    
                    <div className='mt-5'>
                        {showFilterTable &&
                            <CustomFilterTable 
                                formDataFilter={filters}
                                setFormDataFilter={setFilters}
                                onFilteredTable={handleFilterSubmit}
                                isAssegnaCorso={true}
                                isCorsoTelematicaAsincrona={courseData?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA}
                                isLoadingData={loadingStateUtenti.isLoadingUtenteByParams}
                                searchNodeType={(() => {
                                    // 1. Definiamo la lista completa di TUTTI i filtri, nell'ordine esatto in cui devono apparire.
                                    const allPossibleFilters = [
                                        { nodeType: "input", name: "nome" }, 
                                        { nodeType: "input", name: "cognome" }, 
                                        { nodeType: "input", name: "username", placeholder: "email" }, 
                                        { nodeType: "input", name: "id_utente", placeholder: "ID Corsista" },
                                        { nodeType: "select", name: "id_agenzia" }, // Manteniamo il filtro qui, nella sua posizione corretta
                                        { nodeType: "select", name: "stato_pagamento", options: [
                                            { label: "Qualsiasi Stato Pagamento", value: "" }, 
                                            { label: "Non Pagato", value: "Non_pagato" }, 
                                            { label: "Parzialmente Pagato", value: "Parzialmente_pagato" }, 
                                            { label: "Pagato", value: "Pagato" }
                                        ]}
                                    ];

                                    // 2. Applichiamo la regola: se l'utente è un PARTNER, restituisci la lista SENZA il filtro agenzia.
                                    if (userLoggedIn?.role === ROLES.PARTNER) {
                                        // Il metodo .filter() crea un nuovo array escludendo l'elemento che non vogliamo.
                                        return allPossibleFilters.filter(filter => filter.name !== 'id_agenzia');
                                    }

                                    // 3. In tutti gli altri casi (Admin, Developer, etc.), restituisci la lista completa.
                                    return allPossibleFilters;
                                })()}/>
                        }
                    </div>

                    <Nav variant="tabs" activeKey={activeTab} onSelect={handleTabSelect} className="mt-4">
                        <Nav.Item>
                            <Nav.Link eventKey="inCorso">In Corso ({tabCounts.inCorso})</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="inAttesaEsame">In Attesa Esami({tabCounts.completati})</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="archiviati">Formazione Conclusa ({tabCounts.archiviati})</Nav.Link>
                        </Nav.Item>
                    </Nav>
                                        {isLoading ? (
                        <div className='m-auto text-center py-5 mt-5'><p>Caricamento utenti...</p><Spinner animation="border" /></div>
                    ) : (
                        <>
                            {(!utenti || utenti.length === 0) ? (
                                <div className='mt-5 py-5 text-center'><p><b>Nessun utente trovato in questa vista.</b></p></div>
                            ) : (
                                <>
                                    <UsersToCourseManager
                                        users={utenti}
                                        setShowFilterTable={setShowFilterTable}
                                        userLoggedIn={userLoggedIn}
                                        openDeleteCourseModal={openDeleteCourseModal}
                                        openUpdateStatoPagamentoModal={openUpdateStatoPagamentoModal}
                                        openGeneraAttestatoModal={openGeneraAttestatoModal}
                                        openUpdateStatoFatturazioneModal={openUpdateStatoFatturazioneModal}
                                        openSpedizioneModal={openSpedizioneModal}
                                        openVerificaModal={openVerificaModal}
                                        openSelectRecipientModal={openSelectRecipientModal}
                                        onDownloadReport={handleDownloadReport}
                                        isDownloadingReport={loadingStateUtenti.isDownloadingReport} 
                                    />
                                    <div className='my-3 d-flex justify-content-end'>
                                        <CustomPagination
                                            totalPages={totalPages}
                                            selectedPage={currentPage}
                                            handlePageChange={handlePageChange}
                                        />
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            
            <CustomModal show={modalStateCorsiUtenti.assignCourseToUser} onHide={handleCloseModal} headerText="Assegna utente" size={"xl"} btnText={"Salva"} body={renderAssignUserToCourseModal()} isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtentiCreating} onUndoChanges={handleCloseModal} onSave={onAssignCorsiUtente} hideButtons={selectedUsers.length === 0} />
            <CustomModal show={modalStateAttestati.showModalGeneraAttestato} onHide={handleCloseModal} headerText="Genera attestato" size={"lg"} btnText={"Genera"} body={ esamiUtente ? <AttestatiManager utente={esamiUtente.utente} esami={esamiUtente.esami} corso={courseData} classeUtente={{ id_classe_utente: selectedUser?.id_classe_utente }} pathAttestato={selectedUser?.path_attestato_orizzontale} fileRealAttestato={selectedUser?.file_real} onEsameSelect={handleEsameSelect} onGeneraAttestato={onGeneraAttestato} /> : <div className="text-center"><Spinner animation="border" /></div> } closeButton={true} isLoading={loadingStateAttestati.isLoadingGeneraAttestato} onUndoChanges={handleCloseModal} onSave={() => onGeneraAttestato(esamiUtente.esami.find(e => e.id_calendario_esame_utente.toString() === selectedEsame))} hideSaveBtn={!selectedEsame} />
            <CustomModal show={modalStateCorsiUtenti.updateCorsiUtenteModal} onHide={handleCloseModal} headerText="Stato pagamento" size={"md"} btnText={"Salva"} body={renderUpdateCourseInfoPerUserModal()} closeButton={true} isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtenteUpdate} onUndoChanges={handleCloseModal} onSave={onUpdateCorsiUtente} />
            <CustomModal show={modalStateCorsiUtenti.deleteCorsiUtenteModal} onHide={handleCloseModal} headerText="Rimuovi utente" size={"md"} variant={"danger"} btnText={"Rimuovi"} body={renderDeleteCorsiUtente()} isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtenteDeleting} onUndoChanges={handleCloseModal} onSave={onDeleteCorsiUtente} />
            <CustomModal show={modalStateCorsiUtenti.updateStatoFatturazioneModal} onHide={handleCloseModal} headerText="Stato fatturazione" size={"md"} btnText={"Salva"} body={renderUpdateStatoFatturazioneModal()} closeButton={true} isLoading={loadingStateCorsiUtenti.isLoadingCorsiUtenteUpdate} onUndoChanges={handleCloseModal} onSave={onUpdateStatoFatturazione} />
            <CustomModal
                show={showVerificaModal}
                onHide={handleCloseVerificaModal}
                headerText={`Verifica Amministrativa - ${selectedUserForVerifica?.nome} ${selectedUserForVerifica?.cognome}`}
                size={"lg"}
                btnText={"Salva Modifiche"}
                onSave={onSaveVerifica}
                body={
                    <div>
                        <h5>Stato della Verifica</h5>
                        <div className="mb-3">
                            <div className="form-check">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="verificaStatus" 
                                    id="statusDaVerificare" 
                                    value="da_verificare" 
                                    checked={verificaStatus === 'da_verificare'} 
                                    onChange={(e) => setVerificaStatus(e.target.value)} 
                                />
                                <label className="form-check-label" htmlFor="statusDaVerificare">
                                    Da Verificare
                                </label>
                            </div>
                            <div className="form-check">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="verificaStatus" 
                                    id="statusConforme" 
                                    value="conforme" 
                                    checked={verificaStatus === 'conforme'} 
                                    onChange={(e) => setVerificaStatus(e.target.value)} 
                                />
                                <label className="form-check-label" htmlFor="statusConforme">
                                    Conforme
                                </label>
                            </div>
                            <div className="form-check">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="verificaStatus" 
                                    id="statusNonConforme" 
                                    value="non_conforme" 
                                    checked={verificaStatus === 'non_conforme'} 
                                    onChange={(e) => setVerificaStatus(e.target.value)} 
                                />
                                <label className="form-check-label" htmlFor="statusNonConforme">
                                    Non Conforme
                                </label>
                            </div>
                        </div>
                        
                        <h5>Note Amministrative</h5>
                        <textarea
                            className="form-control"
                            rows="4"
                            placeholder="Le note verranno inviate via email all'utente se lo stato è impostato su 'Non Conforme'..."
                            value={verificaNotes}
                            onChange={(e) => setVerificaNotes(e.target.value)}
                        />
                    </div>
                }
            />
            <CustomModal
                show={modalStateAttestati.showSelectRecipientModal} // Stato per mostrare/nascondere
                onHide={handleCloseSelectRecipientModal} // Funzione per chiudere
                headerText="Stampa Busta - Seleziona Destinatario" // Titolo della modale
                size={"s"} // Dimensioni ridotte
                btnText={"Salva e Stampa"} // Testo del pulsante di conferma
                body={
                    // Passa esplicitamente lo stato 'show' alla modale interna
                    <SelectRecipientModal
                        show={modalStateAttestati.showSelectRecipientModal}
                        attestatoData={userForEnvelopePrint}
                        onSubjectChange={handleSubjectChangeForPrint}
                        currentSoggetto={selectedSoggettoForPrint} // <-- PASSA LO STATO CORRENTE
                    />
                }
                isLoading={loadingStateAttestati.isLoadingUpdateSpedizione || loadingStateAttestati.isPrintingEnvelope} // Stato di caricamento per il pulsante
                onUndoChanges={handleCloseSelectRecipientModal} // Funzione per il pulsante Annulla/Chiudi
                // onSave deve triggerare la logica di conferma E passare il soggetto selezionato.
                // Questo richiede una piccola modifica a come SelectRecipientModal comunica il valore.
                // Modifichiamo SelectRecipientModal per usare un callback onSubjectChange
                // E passiamo handleConfirmRecipientAndPrint a onSave.
                // *Vedi modifica a SelectRecipientModal sotto*
                onSave={handleConfirmRecipientAndPrint} // Passa direttamente la funzione di conferma
            />
            <SpedizioneAttestatoModal
                show={modalStateCorsiUtenti.updateSpedizioneModal}
                onHide={handleCloseModal}
                attestatoData={selectedUtente} // Passa i dati dell'utente/attestato selezionato
                onSave={handleSaveSpedizione} // Collega al tuo handler per salvare
                isLoading={loadingStateAttestati.isLoadingUpdateSpedizione} // Passa lo stato di caricamento
                // Se la tua modale usa internamente onUpdate per refreshare, mantienilo:
                // onUpdate={() => fetchUtentiForTab(activeTab, currentPage, filters)}
            />
        </>
    );
};

export default GestioneCorsiUtentiPage;